export default "__VITE_ASSET__BXzaiJNt__"